module.exports = __webpack_public_path__ + "img/scotiabank.8c854334.png";